// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-pages-404-js": () => import("./../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-disclaimer-js": () => import("./../src/pages/disclaimer.js" /* webpackChunkName: "component---src-pages-disclaimer-js" */),
  "component---src-pages-privacy-js": () => import("./../src/pages/privacy.js" /* webpackChunkName: "component---src-pages-privacy-js" */),
  "component---src-scenes-home-scene-index-js": () => import("./../src/scenes/HomeScene/index.js" /* webpackChunkName: "component---src-scenes-home-scene-index-js" */),
  "component---src-scenes-season-scene-index-js": () => import("./../src/scenes/SeasonScene/index.js" /* webpackChunkName: "component---src-scenes-season-scene-index-js" */)
}

